$(document).ready(function(){

// add to triger shop collection page
  $('.collection .card').each((i,e)=>{
    $(e).find('.cartBtn').click(()=>{
      $(e).find('.quick-add__submit').click();
    });
    $(e).find('.quick-add__submit').css('display','none');
  });

  $("a[href='#get-in-touch']").click(function(e){
    e.preventDefault();
    $('html, body').animate({
        scrollTop: $("#shopify-section-template--17469525098711__home_2_TBwG8K").offset().top
    }, 1000);
  });

  
})/*Document End*/